export default "__VITE_ASSET__CBY4t5eN__"